import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-phone',
  templateUrl: './formly-phone.component.html',
  styleUrls: [],
})
export class FormlyPhoneComponent extends FieldType {}
